import rs from "./custom-event-data.js";
import ls from "./custom-event-property-data.js";
import is from "./filter-set.js";
import mi from "./in-app-message-click-data.js";
import ns from "./purchase-data.js";
import us from "./purchase-property-data.js";
import ur from "./push-click-data.js";
import ot from "./trigger-events.js";
import { logger as E } from "../../../shared-lib/index.js";
import { getErrorMessage as ai } from "../../util/error-utils.js";
export default class fi {
  constructor(e, t) {
    (this.type = e), (this.data = t), (this.type = e), (this.data = t);
  }
  km(e, t) {
    return fi._m[this.type] === e && (null == this.data || this.data.sf(t));
  }
  static ef(e, t) {
    let r = null;
    try {
      r = window.atob(e);
    } catch (t) {
      return E.info("Failed to unencode analytics id " + e + ": " + ai(t)), !1;
    }
    return t === r.split("_")[0];
  }
  static fromJson(e) {
    const t = e.type;
    let r = null;
    switch (t) {
      case fi.Ln.OPEN:
      case fi.Ln.qs:
        break;
      case fi.Ln.Rr:
        r = ns.fromJson(e.data);
        break;
      case fi.Ln.bm:
        r = us.fromJson(e.data);
        break;
      case fi.Ln.wr:
        r = ur.fromJson(e.data);
        break;
      case fi.Ln.xe:
        r = rs.fromJson(e.data);
        break;
      case fi.Ln.Em:
        r = ls.fromJson(e.data);
        break;
      case fi.Ln.rm:
        r = mi.fromJson(e.data);
    }
    return new fi(t, r);
  }
  gt() {
    return { t: this.type, d: this.data ? this.data.gt() : null };
  }
  static _u(e) {
    let t,
      r = null;
    switch (e.t) {
      case fi.Ln.OPEN:
      case fi.Ln.qs:
        break;
      case fi.Ln.Rr:
        r = new ns(e.d);
        break;
      case fi.Ln.bm:
        (t = e.d || {}), (r = new us(t.id, is._u(t.pf || [])));
        break;
      case fi.Ln.wr:
        r = new ur(e.d);
        break;
      case fi.Ln.xe:
        r = new rs(e.d);
        break;
      case fi.Ln.Em:
        (t = e.d || {}), (r = new ls(t.e, is._u(t.pf || [])));
        break;
      case fi.Ln.rm:
        r = new mi(e.d);
    }
    return new fi(e.t, r);
  }
}
(fi.Ln = {
  OPEN: "open",
  Rr: "purchase",
  bm: "purchase_property",
  wr: "push_click",
  xe: "custom_event",
  Em: "custom_event_property",
  rm: "iam_click",
  qs: "test",
}),
  (fi._m = {}),
  (fi._m[fi.Ln.OPEN] = ot.OPEN),
  (fi._m[fi.Ln.Rr] = ot.Rr),
  (fi._m[fi.Ln.bm] = ot.Rr),
  (fi._m[fi.Ln.wr] = ot.wr),
  (fi._m[fi.Ln.xe] = ot.xe),
  (fi._m[fi.Ln.Em] = ot.xe),
  (fi._m[fi.Ln.rm] = ot.rm),
  (fi._m[fi.Ln.qs] = ot.qs);
